import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import LogoCarousel from './components/LogoCarousel';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import CursorTrail from './components/CursorTrail';

function App() {
  useEffect(() => {
    // Set meta tags for SEO
    document.title = 'SMARTIN Consultoria | Consultoria Empresarial em Processos, Custos e Pricing';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'SMARTIN Consultoria: Mais de 10 anos de experiência em Consultoria em Processos, Custos Gerenciais, Contribuição Marginal e Pricing. Otimização de processos, análise de custos, formação de preços e gestão financeira estratégica em Londrina-PR.');
    }

    // Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'SMARTIN Consultoria | Consultoria Empresarial em Processos, Custos e Pricing');
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Consultoria especializada em Processos, Custos Gerenciais e Pricing com mais de 10 anos de experiência. Transformando empresas através de otimização de processos, análise de custos e estratégias de pricing.');
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', window.location.href);
    }
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <CursorTrail />
          <Header />
          <main>
            <Hero />
            <LogoCarousel />
            <About />
            <Services />
            <Portfolio />
            <Contact />
          </main>
          <Footer />
          <WhatsAppFloat />
          <Toaster />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
